import React from 'react';
export const NoAvatarProvider = React.createContext();